import { Box, Flex, Icon, Text, useColorModeValue } from "@chakra-ui/react";
import React, { useState, useRef, useEffect } from "react";

function MusicRow(props) {
  const iconColor = useColorModeValue("gray.500", "gray.400");
  const textColor = useColorModeValue("gray.700", "white");
  const [isPlay, setIsPlay] = useState(false)
  const [reload, setReload] = useState(false)
  const { name, date, address, color,logo, action,playaction } = props;


  return (
    <Flex my="1rem" justifyContent="space-between">
      <Flex alignItems="center">
        <Box onClick={playaction}>
          <Icon w="32px" h="32px" ml="20px" color={color ? color : iconColor} as={logo} />
        </Box>
        <Flex direction="column">
          <Text
            fontSize="sm"
            color={textColor}
            fontWeight="bold"
          >
            {name}
          </Text>
          <Text
            fontSize="10px"
            dir="ltr"
            textAlign={"right"}
            color="gray.400"
          >
            {date}
          </Text>
        </Flex>
      </Flex>
      <Box>
        {action}
      </Box>
    </Flex>
  );
}

export default MusicRow;
